import { useState } from "react";
import { TableHead } from "./table";
import { ArrowUpDown, ArrowUp, ArrowDown } from "lucide-react";
import { cn } from "../../lib/utils";

export function SortableTableHead({ column, sortColumn, sortDirection, onSort, className, children, ...props }) {
  const isActive = sortColumn === column;
  
  const handleClick = () => {
    if (onSort) onSort(column);
  };

  return (
    <TableHead
      className={cn("cursor-pointer select-none hover:bg-muted/50 transition-colors", isActive && "bg-muted/30", className)}
      onClick={handleClick}
      {...props}
    >
      <div className="flex items-center gap-1.5">
        <span>{children}</span>
        <span className="text-muted-foreground">
          {isActive ? (sortDirection === "asc" ? <ArrowUp className="h-3.5 w-3.5" /> : <ArrowDown className="h-3.5 w-3.5" />) : <ArrowUpDown className="h-3.5 w-3.5 opacity-50" />}
        </span>
      </div>
    </TableHead>
  );
}

export function useTableSort(defaultColumn = null, defaultDirection = "asc") {
  const [sortColumn, setSortColumn] = useState(defaultColumn);
  const [sortDirection, setSortDirection] = useState(defaultDirection);

  const handleSort = (column) => {
    if (sortColumn === column) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortColumn(column);
      setSortDirection("asc");
    }
  };

  const sortData = (data, customComparators = {}) => {
    if (!sortColumn || !data) return data;
    return [...data].sort((a, b) => {
      if (customComparators[sortColumn]) {
        const result = customComparators[sortColumn](a, b);
        return sortDirection === "asc" ? result : -result;
      }
      let aVal = a[sortColumn];
      let bVal = b[sortColumn];
      if (aVal == null && bVal == null) return 0;
      if (aVal == null) return sortDirection === "asc" ? 1 : -1;
      if (bVal == null) return sortDirection === "asc" ? -1 : 1;
      if (sortColumn.includes("_at") || sortColumn.includes("date")) {
        aVal = new Date(aVal).getTime();
        bVal = new Date(bVal).getTime();
      } else if (typeof aVal !== "number" || typeof bVal !== "number") {
        aVal = String(aVal).toLowerCase();
        bVal = String(bVal).toLowerCase();
      }
      let result = 0;
      if (aVal < bVal) result = -1;
      if (aVal > bVal) result = 1;
      return sortDirection === "asc" ? result : -result;
    });
  };

  return { sortColumn, sortDirection, handleSort, sortData };
}
